import styled from 'styled-components'
import {
  COLOR
} from '../../themes'
export const TextAreaStyle = styled.label`
  display: block;
  width: 100%;

  .textarea-field {
    border: 1px solid ${COLOR.GRAY_6};
    box-sizing: border-box;
    width: 100%;
    border-radius: 4px;
    outline: none;
    height: 100px;
  }

  textarea {
    resize: none;
  }

  .disabled {
    color: ${COLOR.GRAY_24};
    cursor: not-allowed;
    background: ${COLOR.GRAY_2};
    pointer-events: none
  }

  .handleEditModal {
    cursor: not-allowed;
  }
`
